import React, { createContext, useContext, useEffect, useState } from 'react'
import { AuthContext } from '../auth/AuthContext';
import axiosInstance from '../utils/RequestsQueue';
import { showSwalNotification } from '../utils/SwalResponse';
import { StatsContext } from '../stats/StatsContext';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

export const ReportContext = createContext()

export default function ReportProvider({children}) {

    const {authToken, currentUser} = useContext(AuthContext)
    const {fetchStats} = useContext(StatsContext)
    const [loading, setLoading] = useState(false)
    const [issues, setIssues] = useState([])
    const navigate = useNavigate()



    // ================== NEW REPORT ================


    async function addNewReport(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/new`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.error('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
              fetchStats()
          }
      }
    }

  

    // ================== FETCH SINGLE REPORT ================

    async function fetchSingleReport(reportId){
      // if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/details?re_id=${reportId}`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.error('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    


    // ================== FETCH SINGLE ISSUES ================

    async function fetchSingleIssues(issueId){
      // if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/issues/details?is_id=${issueId}`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.error('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    

  

    // ================== FETCH ALL ISSUES ================

    async function fetchAllIssues(){
      // if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/issues`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              setIssues(response?.data?.data) 
    
          } catch (error){
              // console.error('Error Response:',error?.response?.data)
              console.error(error?.response?.data)
          } finally {
              setLoading(false)
          }
      }
    

      useEffect(() => {
        // Fetch once immediately
        fetchAllIssues();
      
        // Set interval to fetch every 5 minutes (300,000 ms)
        const intervalId = setInterval(() => {
          fetchAllIssues();
        }, 5 * 60 * 1000); // 5 minutes
      
        // Cleanup on unmount
        return () => clearInterval(intervalId);
      }, []);
        
  

    // ================== FETCH REPORTS================

    async function fetchReports(type){
       if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/${type}`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.error('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
    // ================== Verify REPORTS================

    async function verifyReport(reportId){
       if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/verify?re_id=${reportId}`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
                fetchStats()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
  
    // ================== spam REPORT================

    async function spamReport(formData){
       if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/spam`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
                fetchStats()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
    // ================== ASSIGN ADMIN(SPECIALIST)================

    async function assignSpecialist(formData){
       if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role === 'admin'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/assign`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
                fetchStats()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
  

    // ================== ADD PROPOSAL ================

    async function addProposals(formData){
      if (!authToken) {
        Swal.fire("Info","Your Auth Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/add`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
                fetchStats()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
  


    // ================== REJECT PROPOSAL ================

    async function rejectProposal(formData){

      if (!authToken) {
        Swal.fire("Info","Your Auth Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/reject`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
            fetchAllIssues()
              setLoading(false)
          }
      }
    }
    
  

    // ================== REVISE PROPOSAL ================

    async function reviseProposal(formData){
      // console.log(authToken, currentUser)
      if (!authToken) {
        Swal.fire("Info","Your Auth Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/revise`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
              fetchAllIssues()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }
    
  


    // ================== APPROVE PROPOSAL ================

    async function approveProposal(formData){
      if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        return navigate("/login")
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/approve`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              fetchAllIssues()
              setLoading(false)
          }
      }
    }
    
  


    // ================== IMPLEMENTED PROPOSED SOLUTION ================

    async function implementedSolution(formData){
       if (!authToken) {
        Swal.fire("Info","Your Session Has Expired Please login again first")

        await navigate("/login")
        return
      }
      if (!!authToken && !!currentUser && currentUser?.role !== 'user'){
          setLoading(true)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/report/solution/implemented`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              // showSwalNotification(response.data)
              if (response?.data?.status === 'success'){
                // window.history.back()
                fetchStats()
              }
              return response?.data
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              // return error?.response?.data
          } finally {
              fetchAllIssues()
              setLoading(false)
          }
      }
    }
    
  



const contextData ={
    loading,setLoading, addNewReport,
    issues, setIssues,fetchSingleIssues,
    fetchSingleReport,fetchReports,
    verifyReport,spamReport,assignSpecialist,
    addProposals,rejectProposal,reviseProposal,
    approveProposal,implementedSolution,
}
  return (
    <ReportContext.Provider value={contextData}>
        {children}
    </ReportContext.Provider>
  )
}
